import { render, staticRenderFns } from "./OwnerCalculator.vue?vue&type=template&id=381fc36d&"
import script from "./OwnerCalculator.vue?vue&type=script&lang=js&"
export * from "./OwnerCalculator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports